export const uiHelper = {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
  getSessionStorage,
  setSessionStorage,
  removeSessionStorage,
  getTodayDate,
  getTomorrowDate,
  padTime,
  getLocation,
  calculateDistance,
  arrayEqual,
  openWindow,
  priceFormatter
}

function getLocalStorage(keyName) {
  return localStorage.getItem(keyName)
}

function setLocalStorage(keyName, keyValue) {
  return localStorage.setItem(keyName, keyValue)
}

function removeLocalStorage(keyName) {
  return localStorage.removeItem(keyName)
}

function getSessionStorage(keyName) {
  return sessionStorage.getItem(keyName)
}

function setSessionStorage(keyName, keyValue) {
  return keyValue && sessionStorage.setItem(keyName, keyValue)
}

function removeSessionStorage(keyName) {
  return sessionStorage.removeItem(keyName)
}

function getTodayDate() {
  return new Date().toISOString().substr(0, 10)
}

function getTomorrowDate() {
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow.toISOString().substr(0, 10)
}

function padTime(timePart) {
  return timePart.toString().padStart(2, '0')
}

function getLocation(currentLocation) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
      currentLocation.latitude = latitude
      currentLocation.longitude = longitude
    })
  }
}

function calculateDistance([lat1, lon1], [lat2, lon2]) {
  const toRadian = (angle) => (Math.PI / 180) * angle
  const distance = (a, b) => (Math.PI / 180) * (a - b)
  const RADIUS_OF_EARTH_IN_KM = 6371

  const dLat = distance(lat2, lat1)
  const dLon = distance(lon2, lon1)

  lat1 = toRadian(lat1)
  lat2 = toRadian(lat2)

  // Haversine Formula
  const a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2)
  const c = 2 * Math.asin(Math.sqrt(a))

  let finalDistance = RADIUS_OF_EARTH_IN_KM * c

  return finalDistance
}

function arrayEqual(array1, array2) {
  const array2Sorted = array2.slice().sort()
  return (
    array1.length === array2.length &&
    array1
      .slice()
      .sort()
      .every(function (value, index) {
        return value === array2Sorted[index]
      })
  )
}

function openWindow(width, height, html) {
  const left = window.screen.width / 2 - (width / 2 + 10)
  const top = window.screen.height / 2 - (height / 2 + 50)
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }))
  return window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`)
}

function priceFormatter(value) {
  return value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
